import React from 'react';
import { Link } from 'react-router-dom';
import { FaCheckCircle, FaArrowRight, FaTrophy, FaUsers, FaMedal, FaHeart } from 'react-icons/fa';
import './About.css';

const PersonalizedTrainingProgram = () => {

    return (
        <div className="about-page">
            {/* Main About Section */}
            <section className="about-main section">
                <div className="container">
                    <div className="about-main-grid">
                        <div className="about-main-content">
                            <h2>Personalized Training Program</h2>
                            <p>
                                The Personalized Training Program at Net Nest Badminton Sports Club is designed for players who seek customized coaching based on their individual needs, goals, and playing style. This program focuses on targeted improvement, faster progress, and overall player development through a structured and flexible training approach.
                            </p>
                            <h2>Program Overview</h2>
                            <p>
                                Unlike group training programs, the personalized training program is tailored specifically for each player. Coaches analyze the player’s current skill level, fitness, strengths, and areas for improvement to create a training plan that delivers maximum results.
                            </p>
                        </div>
                        <div className="about-main-images">
                            <img src="img/Beginner Training Program (1).jpg" alt="Badminton Court" className="main-image" />
                            {/* <img src="https://images.unsplash.com/photo-1599474924187-334a4ae5bd3c?w=400" alt="Training" className="secondary-image" /> */}
                        </div>
                    </div>
                    <div className="about-main-grid">
                        <div className="about-main-content">
                            {/* <span className="section-badge">Who We Are</span> */}
                            <h2>Customized Skill Development</h2>
                            <p>
                                Stroke correction and refinement
                                <br></br>
                                Footwork and movement efficiency
                                <br></br>
                                Shot accuracy, timing, and consistency
                                <br></br>
                                Net play, defense, and attacking techniques
                            </p>
                        </div>
                        <div className="about-main-images">
                            <h2>Individual Fitness & Conditioning Plan</h2>
                            <p>
                                Speed and agility development
                                <br></br>
                                Strength and endurance building
                                <br></br>
                                Flexibility and injury prevention
                                <br></br>
                                Recovery and mobility exercises
                            </p>
                        </div>
                        <div className="about-main-images">
                            <h2>Tactical & Match-Specific Training</h2>
                            <p>
                                Match strategy development
                                <br></br>
                                Opponent analysis and shot selection
                                <br></br>
                                Singles or doubles-specific positioning
                                <br></br>
                                Score management and pressure handling
                            </p>
                        </div>
                        <div className="about-main-images">
                            <h2>Continuous Performance Assessment</h2>
                            <p>
                                Track progress and performance metrics
                                <br></br>
                                Review match play and training outcomes
                                <br></br>
                                Adjust training intensity and focus areas
                            </p>
                        </div>
                        <div className="about-main-images">
                            <h2>Flexible Training Schedule</h2>
                            <p>
                                Students
                                <br></br>
                                Working professionals
                                <br></br>
                                Competitive athletes
                            </p>
                        </div>
                        <div className="about-main-images">
                            <h2>Mental Strength & Confidence Building</h2>
                            <p>
                                Focus and concentration techniques
                                <br></br>
                                Confidence enhancement
                                <br></br>
                                Stress and pressure management
                                <br></br>
                                Positive competitive mindset
                            </p>
                        </div>
                        <div className="about-main-images">
                            <h2>Suitable for All Skill Levels</h2>
                            <p>
                                Beginners needing special attention
                                <br></br>
                                Intermediate players aiming for faster improvement
                                <br></br>
                                Advanced athletes preparing for competitions
                                <br></br>
                                Players returning from injury or long breaks
                            </p>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default PersonalizedTrainingProgram;